import { CheckIcon } from './Icons';

interface InterestCheckProps {
  checked: boolean;
  label: string;
  onToggle: () => void;
  /**
   * Labeled picker chip (Favorites “What I care about”). Place/club/yoga
   * rows omit this and still use the same pill — checkmark only, no extra
   * name next to the heading.
   */
  chip?: boolean;
}

export function InterestCheck({ checked, label, onToggle, chip = false }: InterestCheckProps) {
  const on = checked ? ' interest-chip--on' : '';
  const compact = chip ? '' : ' interest-chip--compact';
  return (
    <button
      type="button"
      className={`interest-chip${compact}${on}`}
      aria-pressed={checked}
      aria-label={checked ? `Remove ${label} from Favorites` : `Add ${label} to Favorites`}
      onClick={(e) => {
        e.preventDefault();
        e.stopPropagation();
        onToggle();
      }}
    >
      <CheckIcon checked={checked} />
      {chip ? <span>{label}</span> : null}
    </button>
  );
}
